class StickyAddToCartBase extends HTMLElement {
  constructor() {
    super();
    this.originalAddToCart = this.getPrimaryAddToCartTrigger();
    this.inventory_label = document.querySelector('.product__inventory-label');
  }

  getPrimaryAddToCartTrigger() {
    const candidateButtons = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"]'));
    return (
      candidateButtons.find((button) => {
        return !button.closest('sticky-add-to-cart, sticky-add-to-cart-desktop, #stickyAddToCart, #stickyAddToCartDesktop');
      }) || null
    );
  }

  getSoldoutTrigger() {
    const candidates = Array.from(document.querySelectorAll('.buy-buttons-soldout-msg'));
    return candidates.find(el => !el.closest('sticky-add-to-cart, sticky-add-to-cart-desktop, #stickyAddToCart, #stickyAddToCartDesktop')) || null;
  }

  getCurrentVariantFromMainForm() {
    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const mainVariantInput = mainForm?.querySelector('input[name="id"]');
    const variantId = mainVariantInput?.value;
    if (!variantId) return null;

    const variantDataScript = document.querySelector('variant-selects script[type="application/json"]');
    if (!variantDataScript) return null;

    try {
      const variants = JSON.parse(variantDataScript.textContent);
      return variants.find(v => String(v.id) === String(variantId)) || null;
    } catch (e) {
      return null;
    }
  }

  formatPowerValue(value) {
    if (value === null || value === undefined) return '';

    const rawValue = String(value).trim();
    const normalizedValue = rawValue.replace(',', '.');
    const isNumeric = /^[-+]?\d+(?:[\.,]\d+)?$/.test(rawValue);

    if (!isNumeric) return rawValue;

    const parsedValue = Number(normalizedValue);
    if (Number.isNaN(parsedValue)) return rawValue;

    const formattedValue = parsedValue.toFixed(2);
    if (parsedValue > 0) return '+' + formattedValue;

    return formattedValue;
  }

  updateButtonText() {
    const button = this.sticky.querySelector('button[name="add"]');
    const buttonText = this.sticky.querySelector('.buttonText');
    const notifyIcon = this.sticky.querySelector('.sticky-notify-icon');
    if (!button || !buttonText) return;
    
    // Verifica disponibilità dalla variante selezionata nel form principale
    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const mainVariantInput = mainForm?.querySelector('input[name="id"]');
    const variantId = mainVariantInput?.value;
    
    // Cerca nei dati varianti se disponibili
    let isAvailable = true;
    if (variantId) {
      const variantDataScript = document.querySelector('variant-selects script[type="application/json"]');
      if (variantDataScript) {
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const currentVariant = variants.find(v => String(v.id) === String(variantId));
          if (currentVariant) {
            isAvailable = currentVariant.available;
          }
        } catch (e) {
          // Fallback: usa inventory_label
          isAvailable = !!this.inventory_label;
        }
      } else {
        isAvailable = !!this.inventory_label;
      }
    } else {
      isAvailable = !!this.inventory_label;
    }

    if (isAvailable) {
      button.style.display = '';
      buttonText.textContent = 'ADD TO CART';
      button.removeAttribute('disabled');
      button.style.cursor = '';
      button.style.pointerEvents = '';
      button.style.backgroundColor = '';
      button.style.color = '';
      if (notifyIcon) notifyIcon.classList.add('tw-hidden');
    } else {
      // FGX-hide-notify-sticky: hide CTA when OOS
      button.style.display = 'none';
      // buttonText.textContent = 'NOTIFY ME';
      // button.removeAttribute('disabled');
      // button.style.cursor = '';
      // button.style.pointerEvents = '';
      // if (notifyIcon) notifyIcon.classList.remove('tw-hidden');
    }
  }
}
function dismissStickyATC() {
  // La sticky bar non viene più nascosta dopo l'add to cart
  // const stickies = document.querySelectorAll('#stickyAddToCart, #stickyAddToCartDesktop');
  // stickies.forEach((el) => {
  //   if (!el) return;
  //   el.classList.add('is-dismissed', 'tw-hidden');
  //   el.style.display = 'none';
  // });
}

function installGlobalAddToCartListeners() {
  const onSubmit = (e) => {
    const form = e.target.closest && e.target.closest('form[data-type="add-to-cart-form"]');
    if (form) dismissStickyATC();
  };

  const onClick = (e) => {
    const btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (!btn) return;
    // Se è un bottone notify-me (apre il modale), apri il modal e non fare dismiss
    if (btn.classList.contains('notify-me-open')) {
      const modal = document.getElementById('notify-me-modal');
      if (modal && modal.showModal) {
        modal.classList.remove('tw-opacity-0');
        modal.showModal();
        document.body.classList.add('tw-overflow-hidden');
      }
      return;
    }
    const form = btn.closest('form[data-type="add-to-cart-form"]');
    if (form) dismissStickyATC();
  };

  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('click', onClick, true);
  window.__stickyATC__removers = [
    () => document.removeEventListener('submit', onSubmit, true),
    () => document.removeEventListener('click', onClick, true),
  ];
}
if (!window.__stickyATC__installed) {
  installGlobalAddToCartListeners();
  window.__stickyATC__installed = true;
}

class StickyAddToCartMobile extends StickyAddToCartBase {
  constructor() {
    super();
    this.sticky = this.querySelector('#stickyAddToCart');
    this.cartNotification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this._rafId = null;
    this._isVisible = false;
  }

  connectedCallback() {
    if (window.innerWidth > 999) return;
    
    // Retry per trovare originalAddToCart se non trovato nel constructor
    if (!this.originalAddToCart) {
      this.originalAddToCart = this.getPrimaryAddToCartTrigger();
    }
    this.soldoutTrigger = this.getSoldoutTrigger();
    
    // Usa requestAnimationFrame invece di debounce per evitare bouncing
    const rafScroll = () => {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this.handleScroll();
        this._rafId = null;
      });
    };
    
    window.addEventListener('scroll', rafScroll, { passive: true });
    window.addEventListener('resize', rafScroll, { passive: true });
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
    this.setup();
    
    // Imposta stile iniziale per transizione fade
    this.sticky.style.transition = 'opacity 0.25s ease-in-out, transform 0.25s ease-in-out';
    this.sticky.style.opacity = '0';
    this.sticky.style.transform = 'translateY(100%)';
    this.sticky.classList.remove('tw-hidden');
    
    // Forza visibilità iniziale e poi lascia che handleScroll decida
    requestAnimationFrame(() => this.handleScroll());
  }

  setup() {
    this.sticky = this.querySelector('#stickyAddToCart');
    this.buttonAddToCartText = this.sticky.querySelector('.buttonText');
    this.outOfStockBadge = this.sticky.querySelector('.sticky-out-of-stock-badge');
    this.inventory_label = document.querySelector('.product__inventory-label');
    this.updateButtonText();
  }

  onVariantChange(event) {
    const variant = event?.data?.variant;
    if (!variant) return;

    // Aggiorna badge Out of stock
    if (this.outOfStockBadge) {
      this.outOfStockBadge.classList.toggle('tw-hidden', variant.available);
    }

    // Aggiorna variant ID nell'input hidden
    const variantInput = this.sticky.querySelector('input.sticky-variant-id');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Aggiorna prezzo dinamicamente
    this.updatePrice(variant);

    // Aggiorna stato bottone in base alla disponibilità della variante
    this.updateButtonState(variant.available);
  }

  updatePrice(variant) {
    const priceContainer = this.sticky.querySelector('.sticky-add-to-cart__price');
    if (!priceContainer) return;

    // Nascondi tutti i div mobile-showpricing
    const allShowpricing = priceContainer.querySelectorAll('.mobile-showpricing');
    allShowpricing.forEach(el => el.classList.add('tw-hidden'));

    // Mostra il div corrispondente alla variante corrente
    const variantPrice = priceContainer.querySelector(`#mobile-prices-${variant.id}`);
    if (variantPrice) {
      variantPrice.classList.remove('tw-hidden');
    } else {
      // Fallback: mostra il primo (default)
      const firstShowpricing = priceContainer.querySelector('.mobile-showpricing');
      if (firstShowpricing) {
        firstShowpricing.classList.remove('tw-hidden');
      }
    }
  }

  updateButtonState(isAvailable) {
    const button = this.sticky.querySelector('button[name="add"]');
    const buttonText = this.sticky.querySelector('.buttonText');
    const notifyIcon = this.sticky.querySelector('.sticky-notify-icon');
    if (!button || !buttonText) return;

    if (isAvailable) {
      button.style.display = '';
      buttonText.textContent = 'ADD TO CART';
      button.setAttribute('type', 'submit');
      button.classList.remove('notify-me-open');
      button.removeAttribute('aria-haspopup');
      button.removeAttribute('aria-controls');
      button.removeAttribute('disabled');
      button.classList.remove('tw-opacity-60');
      button.style.cursor = '';
      button.style.pointerEvents = '';
      if (notifyIcon) notifyIcon.classList.add('tw-hidden');
    } else {
      // FGX-hide-notify-sticky: hide CTA when OOS
      button.style.display = 'none';
      // buttonText.textContent = 'NOTIFY ME';
      // button.setAttribute('type', 'button');
      // button.classList.add('notify-me-open');
      // button.setAttribute('aria-haspopup', 'dialog');
      // button.setAttribute('aria-controls', 'notify-me-modal');
      // button.removeAttribute('disabled');
      // button.classList.remove('tw-opacity-60');
      // button.style.cursor = '';
      // button.style.pointerEvents = '';
      // if (notifyIcon) notifyIcon.classList.remove('tw-hidden');
    }
  }

  isHeaderVisible() {
    return this.header && this.header.offsetHeight > 0 && this.header.getBoundingClientRect().top < window.innerHeight;
  }

  showSticky() {
    if (this._isVisible) return;
    this._isVisible = true;
    this.sticky.style.opacity = '1';
    this.sticky.style.transform = 'translateY(0)';
    this.sticky.style.pointerEvents = 'auto';
  }

  hideSticky() {
    if (!this._isVisible) return;
    this._isVisible = false;
    this.sticky.style.opacity = '0';
    this.sticky.style.transform = 'translateY(100%)';
    this.sticky.style.pointerEvents = 'none';
  }

  handleScroll = () => {
    // if (this.sticky && this.sticky.classList.contains('is-dismissed')) return;

    // Se non troviamo il bottone principale, riprova a risolverlo
    if (!this.originalAddToCart) {
      this.originalAddToCart = this.getPrimaryAddToCartTrigger();
    }
    if (!this.soldoutTrigger) {
      this.soldoutTrigger = this.getSoldoutTrigger();
    }
    if (!this.originalAddToCart && !this.soldoutTrigger) {
      this.hideSticky();
      return;
    }
    
    if (window.innerWidth > 999) {
      this.showSticky();
      return;
    }
    
    let shouldHide = false;

    // Check add-to-cart button visibility
    if (this.originalAddToCart) {
      const buyButtonRect = this.originalAddToCart.getBoundingClientRect();
      if (buyButtonRect.height > 0 && buyButtonRect.top < window.innerHeight && buyButtonRect.bottom > 0) {
        shouldHide = true;
      }
    }

    // Check soldout message visibility (OOS)
    if (!shouldHide && this.soldoutTrigger) {
      const soldoutRect = this.soldoutTrigger.getBoundingClientRect();
      if (soldoutRect.height > 0 && soldoutRect.top < window.innerHeight && soldoutRect.bottom > 0) {
        shouldHide = true;
      }
    }
    
    if (shouldHide) {
      this.hideSticky();
    } else {
      this.showSticky();
    }
    
    const scrollTop = window.scrollY;
    const triggerHeight = this.originalAddToCart.getBoundingClientRect().top + window.scrollY;
    if (window.innerWidth <= 999 && this.cartNotification) {
      const isCartNotificationOpen =
        this.cartNotification.classList.contains('active') ||
        this.cartNotification.classList.contains('active-with-sticky');

      if (isCartNotificationOpen) {
        return;
      }

      if (this.cartNotification.classList.contains('active') && scrollTop > triggerHeight) {
        this.cartNotification.classList.remove('active');
        this.cartNotification.classList.add('active-with-sticky');
      } else if (this.cartNotification.classList.contains('active-with-sticky') && scrollTop < triggerHeight) {
        this.cartNotification.classList.remove('active-with-sticky');
        this.cartNotification.classList.add('active');
      }
    }
  }
}

if (!customElements.get('sticky-add-to-cart')){
  customElements.define('sticky-add-to-cart', StickyAddToCartMobile);
}
class StickyAddToCartDesktop extends StickyAddToCartBase {
  constructor() {
    super();
    this.sticky = this.querySelector('#stickyAddToCartDesktop');
    this._io = null;
    this._isVisible = false;
  }

  connectedCallback() {
    this.setup();
    this.syncInitialVariantState();
    this.initObserver();
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
    
    // Imposta stile iniziale per transizione fade
    this.sticky.style.transition = 'opacity 0.25s ease-in-out, transform 0.25s ease-in-out';
    this.sticky.style.opacity = '0';
    this.sticky.style.transform = 'translateY(100%)';
    this.sticky.classList.remove('tw-hidden');
  }

  syncInitialVariantState() {
    const initialVariant = this.getCurrentVariantFromMainForm();
    if (!initialVariant) return;

    this.onVariantChange({ data: { variant: initialVariant } });
  }

  setup() {
    this.sticky = this.querySelector('#stickyAddToCartDesktop');
    this.buttonAddToCartText = this.sticky.querySelector('.buttonText');
    this.outOfStockBadge = this.sticky.querySelector('.sticky-out-of-stock-badge');
    this.powerSpan = this.sticky.querySelector('.sticky-add-to-cart__power');
    this.colorSpan = this.sticky.querySelector('.sticky-add-to-cart__color');
    this.inventory_label = document.querySelector('.product__inventory-label');

    // Memorizza l'immagine di default per fallback
    const imageEl = this.sticky.querySelector('[data-sticky-image]');
    if (imageEl) {
      this.defaultImageSrc = imageEl.getAttribute('data-default-src') || imageEl.src;
    }

    this.updateButtonText();
  }

  onVariantChange(event) {
    const variant = event?.data?.variant;
    if (!variant) return;

    // Aggiorna badge Out of stock
    if (this.outOfStockBadge) {
      this.outOfStockBadge.classList.toggle('tw-hidden', variant.available);
    }

    // Aggiorna power e color usando i data-attributes
    const optionsContainer = this.sticky.querySelector('.sticky-add-to-cart__options');
    if (optionsContainer) {
      const powerIndex = optionsContainer.dataset.powerIndex;
      const colorIndex = optionsContainer.dataset.colorIndex;

      if (powerIndex && this.powerSpan) {
        const powerValue = variant['option' + powerIndex];
        if (powerValue) {
          this.powerSpan.textContent = this.formatPowerValue(powerValue);
        }
      }

      if (colorIndex && this.colorSpan) {
        const colorValue = variant['option' + colorIndex];
        if (colorValue) {
          this.colorSpan.textContent = colorValue;
        }
      }
    }

    // Aggiorna variant ID nell'input hidden
    const variantInput = this.sticky.querySelector('input.sticky-variant-id');
    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Aggiorna immagine in base al colore
    this.updateImage(variant);

    // Aggiorna prezzo mostrando/nascondendo i div pre-renderizzati
    this.updatePrice(variant);

    // Aggiorna stato bottone in base alla disponibilità della variante
    this.updateButtonState(variant.available);
  }

  updatePrice(variant) {
    const priceContainer = this.sticky.querySelector('.sticky-add-to-cart__price');
    if (!priceContainer) return;

    // Nascondi tutti i div desktop-showpricing
    const allShowpricing = priceContainer.querySelectorAll('.desktop-showpricing');
    allShowpricing.forEach(el => el.classList.add('tw-hidden'));

    // Mostra il div corrispondente alla variante corrente
    const variantPrice = priceContainer.querySelector(`#desktop-prices-${variant.id}`);
    if (variantPrice) {
      variantPrice.classList.remove('tw-hidden');
    } else {
      // Se non c'è un div specifico per questa variante, mostra il primo (default)
      const firstShowpricing = priceContainer.querySelector('.desktop-showpricing');
      if (firstShowpricing) {
        firstShowpricing.classList.remove('tw-hidden');
      }
    }
  }

  updateImage(variant) {
    const imageEl = this.sticky.querySelector('[data-sticky-image]');
    if (!imageEl) return;

    const optionsContainer = this.sticky.querySelector('.sticky-add-to-cart__options');
    const colorIndex = optionsContainer?.dataset?.colorIndex;
    const colorValue = colorIndex ? variant['option' + colorIndex] : null;

    // 1. Priorità: usa metafield meta_images per colore (sempre affidabile)
    if (optionsContainer && colorIndex && colorValue) {
      const newImageUrl = this.getVariantImageByColor(colorValue);
      if (newImageUrl) {
        imageEl.src = newImageUrl;
        imageEl.alt = colorValue;
        return;
      }
    }

    // 2. Fallback: sincronizza con l'immagine attiva della gallery PDP
    const mainGalleryImg = this.getMainGalleryImageElement();
    if (mainGalleryImg && mainGalleryImg.src) {
      imageEl.src = mainGalleryImg.src;
      return;
    }

    // 3. Fallback: featured_image dalla variante (può essere inaffidabile)
    if (variant.featured_image && variant.featured_image.src) {
      imageEl.src = variant.featured_image.src;
      imageEl.alt = variant.featured_image.alt || variant.title || '';
      return;
    }

    // 4. Ultimate fallback: immagine di default memorizzata al setup
    if (this.defaultImageSrc) {
      imageEl.src = this.defaultImageSrc;
    }
  }

  getMainGalleryImageElement() {
    const selectors = [
      '.pdp-gallery-grid__main-image .product-media-container .product__media img',
      '.pdp-gallery-grid__main-image .product__media img',
      '.product__media-list .product__media.is-active .product__media img',
      '.product__media-list .product__media.is-active img'
    ];

    for (const selector of selectors) {
      const candidate = document.querySelector(selector);
      if (!candidate) continue;

      const candidateClasses = candidate.className || '';
      const candidateSrc = candidate.getAttribute('src') || '';
      const isLogo = candidateClasses.includes('pdp-gallery-grid__logo-img') || candidate.closest('.pdp-gallery-grid__logo');
      const isZoomIcon = candidate.closest('.pdp-gallery-grid__tablet-zoom-btn') || candidateSrc.includes('Frame_1373933');

      if (isLogo || isZoomIcon) continue;
      return candidate;
    }

    return null;
  }

  getVariantImageByColor(colorValue) {
    // Cerca nel CustomVariantsScript
    const script = document.querySelector('#CustomVariantsScript');
    if (!script) return null;

    try {
      const customVariants = JSON.parse(script.textContent);
      const matchingVariant = customVariants.find(v => 
        v.color === colorValue && v.meta_images && v.meta_images !== '#N/D'
      );

      if (matchingVariant && matchingVariant.meta_images) {
        const firstImage = matchingVariant.meta_images.split(',')[0].toLowerCase();
        if (firstImage) {
          // Cerca l'URL immagine negli script-gallery-images
          const scriptSlides = document.querySelectorAll('.script-gallery-images script');
          for (const scriptEl of scriptSlides) {
            const scriptImgSrc = scriptEl.getAttribute('data-img-src');
            if (scriptImgSrc && scriptImgSrc.toLowerCase().includes(firstImage)) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = scriptEl.innerHTML;
              const img = tempDiv.querySelector('img');
              if (img && img.src) {
                return img.src;
              }
            }
          }
        }
      }
    } catch (e) {
      console.error('Error parsing CustomVariantsScript:', e);
    }

    return null;
  }

  updateButtonState(isAvailable) {
    const button = this.sticky.querySelector('button[name="add"]');
    const buttonText = this.sticky.querySelector('.buttonText');
    const notifyIcon = this.sticky.querySelector('.sticky-notify-icon');
    if (!button || !buttonText) return;

    if (isAvailable) {
      button.style.display = '';
      buttonText.textContent = 'ADD TO CART';
      button.removeAttribute('disabled');
      button.classList.remove('tw-opacity-60');
      button.setAttribute('type', 'submit');
      button.classList.remove('notify-me-open');
      button.removeAttribute('aria-haspopup');
      button.removeAttribute('aria-controls');
      button.style.cursor = '';
      button.style.pointerEvents = '';
      button.style.backgroundColor = '';
      button.style.color = '';
      if (notifyIcon) notifyIcon.classList.add('tw-hidden');
    } else {
      // FGX-hide-notify-sticky: hide CTA when OOS
      button.style.display = 'none';
      // buttonText.textContent = 'NOTIFY ME';
      // button.removeAttribute('disabled');
      // button.classList.remove('tw-opacity-60');
      // button.setAttribute('type', 'button');
      // button.classList.add('notify-me-open');
      // button.setAttribute('aria-haspopup', 'dialog');
      // button.setAttribute('aria-controls', 'notify-me-modal');
      // button.style.cursor = '';
      // button.style.pointerEvents = '';
      // if (notifyIcon) notifyIcon.classList.remove('tw-hidden');
    }
  }

  initObserver() {
    if (!this.originalAddToCart) {
      this.originalAddToCart = this.getPrimaryAddToCartTrigger();
    }
    this.soldoutTrigger = this.getSoldoutTrigger();

    if ((!this.originalAddToCart && !this.soldoutTrigger) || !this.sticky) return;

    if (this._io) this._io.disconnect();

    // Track visibility of both trigger elements
    this._triggerInView = { button: false, soldout: false };

    this._io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target === this.originalAddToCart) {
          this._triggerInView.button = entry.isIntersecting;
        } else if (entry.target === this.soldoutTrigger) {
          this._triggerInView.soldout = entry.isIntersecting;
        }
      });

      if (this._triggerInView.button || this._triggerInView.soldout) {
        this.hideSticky();
      } else {
        this.showSticky();
      }
    }, { threshold: 0 });

    if (this.originalAddToCart) this._io.observe(this.originalAddToCart);
    if (this.soldoutTrigger) this._io.observe(this.soldoutTrigger);

    // Check initial state
    let initialInView = false;
    if (this.originalAddToCart) {
      const r = this.originalAddToCart.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom > 0) initialInView = true;
    }
    if (!initialInView && this.soldoutTrigger) {
      const r = this.soldoutTrigger.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && r.bottom > 0) initialInView = true;
    }
    if (initialInView) {
      this.hideSticky();
    } else {
      this.showSticky();
    }
  }

  showSticky() {
    if (this._isVisible) return;
    this._isVisible = true;
    this.sticky.style.opacity = '1';
    this.sticky.style.transform = 'translateY(0)';
    this.sticky.style.pointerEvents = 'auto';
  }

  hideSticky() {
    if (!this._isVisible) return;
    this._isVisible = false;
    this.sticky.style.opacity = '0';
    this.sticky.style.transform = 'translateY(100%)';
    this.sticky.style.pointerEvents = 'none';
  }
}

if (!customElements.get('sticky-add-to-cart-desktop')){
  customElements.define('sticky-add-to-cart-desktop', StickyAddToCartDesktop);
}
